import type React from 'react';
import { useState } from 'react';

import { OrdCreateInDialogButton } from '@ragu-components/ord-components';
import { ResourceContextProvider, useNotify, useRefresh } from 'react-admin';

import { PersonalAccessTokensForm } from './PersonalAccessTokensForm';
import { PersonalAccessTokensInfoDialog } from './PersonalAccessTokensInfoDialog';

import type { PersonalAccessTokenCreateResponse } from '@ragu-components/ord-types';
import type { CreateInDialogButtonProps } from '@ratto-components/ra-form-layout';

export const PersonalAccessTokensCreateInDialogButton = (props: CreateInDialogButtonProps): React.ReactElement => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [showDialog, setShowDialog] = useState(false);
  const [dialogContent, setDialogContent] = useState<PersonalAccessTokenCreateResponse | undefined>();
  const onSuccess = (data: PersonalAccessTokenCreateResponse): void => {
    setDialogContent(data);
    setShowDialog(true);
    notify('ra.notification.created', { messageArgs: { smart_count: 1 } });
    refresh();
  };
  return (
    <>
      <ResourceContextProvider value='me/personal_access_tokens'>
        <OrdCreateInDialogButton fullWidth {...props} mutationOptions={{ onSuccess }}>
          <PersonalAccessTokensForm />
        </OrdCreateInDialogButton>
      </ResourceContextProvider>
      <PersonalAccessTokensInfoDialog open={showDialog} dialogContent={dialogContent} setOpen={setShowDialog} />
    </>
  );
};
